import { Model, table, field, primary } from '@tencent/memoire-structured-storage';
import { TABLE_NAME } from '../constants';
import type { IMutationsPackExtended } from '../persistent';

export interface IPersistentStoreItem {
    id: string;
    mutationsPacks: IMutationsPackExtended[];
}

@table(TABLE_NAME)
export class MutationsPacksModel extends Model implements IPersistentStoreItem {
    @primary()
    public id: string;

    @field()
    public mutationsPacks: IMutationsPackExtended[];

    public constructor({ id, mutationsPacks }: IPersistentStoreItem) {
        super();
        this.id = id;
        this.mutationsPacks = mutationsPacks;
    }

    public getMutationsPacks() {
        return this.mutationsPacks || [];
    }
}
